import { Permission } from './Permission';

export class Role {

  public readonly locKey: string;
  public readonly permissions: _.Dictionary<Permission>;

  /*
   * Creates a role where all the given capabilities have the given permission
   */
  public static create(locKey: string, capabilities: string[], permission: Permission): Role {
    return Role.build(locKey).specify(permission, ...capabilities).finish();
  }

  /*
   * Creates a role using a builder style interface.
   */
  public static build(locKey: string): IRoleBuilder {
    return new RoleBuilder(locKey);
  }
}

export interface IRoleBuilder {
  allow(...capabilities: string[]): IRoleBuilder;
  deny(...capabilities: string[]): IRoleBuilder;
  specify(permission: Permission, ...capabilities: string[]): IRoleBuilder;
  unspecify(permission: Permission, ...capabilities: string[]): IRoleBuilder;
  finish(): Role;
}

class RoleBuilder implements IRoleBuilder {
  private locKey: string;
  private capabilities: _.Dictionary<Permission> = {};

  constructor(locKey: string) {
    this.locKey = locKey;
  }

  allow(...capabilities: string[]): IRoleBuilder {
    return this.specify(Permission.Allowed, ...capabilities);
  }

  deny(...capabilities: string[]): IRoleBuilder {
    return this.specify(Permission.Denied, ...capabilities);
  }

  specify(permission: Permission, ...capabilities: string[]): IRoleBuilder {
    capabilities.forEach(c => this.capabilities[c] = permission);
    return this;
  }

  unspecify(permission: Permission, ...capabilities: string[]): IRoleBuilder {
    return this.specify(Permission.Unspecified, ...capabilities);
  }

  finish(): Role {
    return {
      locKey: this.locKey,
      permissions: this.capabilities
    };
  }
}
